module.exports = __webpack_public_path__ + "../../../../../wp-content/themes/mortenbruvold/app/dist/img/user.1b8be325.svg";